var gvUrl=window.gvUrl||(window.gvUrl=function(p){var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';return r+String(p).replace(/^\//,'')});
/* ══════════════════════════════════════════════════════════════════════
   GV — CADEAUX AUTOMATIQUES  (02/09/2026)

   Ce script n'a AUCUNE intelligence métier : c'est Liquid qui décide.
   gv-cadeaux.liquid publie l'état voulu et l'état actuel ; on applique
   seulement l'écart.

   DÉCLENCHEMENT — on n'attend pas que le thème veuille bien recharger le
   volet. Toute écriture panier (add / change / update / clear), d'où
   qu'elle vienne, est détectée ; on redemande alors à Liquid un état frais
   avant d'agir. Sans ça, un panier modifié par un chemin qui ne recharge
   pas le volet garderait un état périmé et le cadeau manquerait au
   paiement — c'est exactement ce qu'a montré le test du 02/09.

   Le setInterval reste en filet de sécurité : il ne fait qu'une lecture
   DOM et ne déclenche aucune requête tant que l'état est convergé.
   (rAF et IntersectionObserver sont gelés par le scanner du thème.)
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var TICK = 1500;
  var MAX_PASSES = 6;      // garde-fou si une correction échoue en boucle
  var passes = 0;
  var busy = false;
  var attente = null;

  /* On ne touche jamais au panier depuis l'éditeur : Paul y travaille. */
  if (window.Shopify && window.Shopify.designMode) return;

  var _fetch = window.fetch.bind(window);
  var MARQUEUR = 'X-GV-Cadeaux';   // nos propres écritures, à ne pas réentendre

  function post(url, corps) {
    var h = { 'Content-Type': 'application/json', Accept: 'application/json' };
    h[MARQUEUR] = '1';
    return _fetch(url, { method: 'POST', headers: h, body: JSON.stringify(corps) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r; });
  }

  function idSection() {
    var sc = document.querySelector('side-cart');
    var h = sc && sc.closest('[data-section-id]');
    return h ? h.dataset.sectionId : null;
  }

  /* La balise du volet fait foi quand elle existe : c'est celle que
     reloadSidecart() remplace. Sinon, notre copie de secours. */
  function balise() {
    return document.querySelector('#SideCartContent [data-gv-cadeaux-etat]')
        || document.querySelector('[data-gv-cadeaux-etat]');
  }

  function etat() {
    var b = balise();
    if (!b) return null;
    try { return JSON.parse(b.textContent); } catch (e) { return null; }
  }

  /* Redemande à Liquid l'état réel, sans recharger la page. */
  function rafraichir() {
    var sid = idSection();
    if (!sid) return Promise.resolve();
    var u;
    try { u = new URL(window.location.href); } catch (e) { return Promise.resolve(); }
    u.searchParams.set('sections', sid);
    return _fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'reload' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j[sid];
        if (!html) return;
        var t = document.createElement('template');
        t.innerHTML = html;
        var neuve = t.content.querySelector('[data-gv-cadeaux-etat]');
        var ancienne = balise();
        if (neuve && ancienne) { ancienne.textContent = neuve.textContent; return; }
        if (neuve && !ancienne) { document.body.appendChild(neuve.cloneNode(true)); return; }
        /* Panier devenu vide : plus de balise rendue, donc plus rien à faire. */
        if (!neuve && ancienne) ancienne.textContent = '{}';
      });
  }

  function applique(c) {
    if (!c || c.voulu === c.actuel) return null;
    if (c.actuel === 0) return post(gvUrl('/cart/add.js'), { id: c.id, quantity: c.voulu });
    if (!c.cle) return null;
    return post(gvUrl('/cart/change.js'), { id: c.cle, quantity: c.voulu });
  }

  function sync() {
    if (busy) return;
    var e = etat();
    if (!e || !e.tube || !e.gousse) return;

    var travaux = [];
    if (e.tube.voulu !== e.tube.actuel) travaux.push(e.tube);
    if (e.gousse.voulu !== e.gousse.actuel) travaux.push(e.gousse);
    if (!travaux.length) { passes = 0; return; }

    passes += 1;
    if (passes > MAX_PASSES) return;
    busy = true;

    /* En série : l'API panier ne supporte pas les écritures concurrentes,
       et le tube payant peut écrire au même moment. */
    var chaine = Promise.resolve();
    travaux.forEach(function (c) { chaine = chaine.then(function () { return applique(c); }); });

    chaine
      .catch(function () {
        /* Une ecriture a echoue : on ne s arrete pas la. On repart de l etat
           serveur reel, sinon la passe suivante raisonne sur des donnees
           fausses (cle de ligne perimee, quantite deja appliquee). */
      })
      .then(rafraichir)
      .then(function () {
        var sc = document.querySelector('side-cart');
        if (sc && sc.reloadSidecart) return sc.reloadSidecart().then(function () {
          if (sc.updateCartCount) sc.updateCartCount();
        });
        if (sc && sc.updateCartCount) sc.updateCartCount();
      })
      .catch(function () {
        /* Silence volontaire : un cadeau non ajouté ne doit JAMAIS empêcher
           un client de commander. Le tick suivant retentera. */
      })
      .then(function () { busy = false; });
  }

  function planifier() {
    clearTimeout(attente);
    attente = setTimeout(function () {
      /* Toute ecriture panier exterieure ouvre un NOUVEAU cycle : sans cette
         remise a zero, six echecs successifs (reseau, 429) eteignaient les
         cadeaux jusqu au recharg. de la page, alors que le bloc vert
         continuait de les promettre au client. */
      passes = 0;
      rafraichir().then(sync).catch(function () {});
    }, 600);   // on laisse le tube payant (debounce 400 ms) finir d'écrire
  }

  /* ── Détection des écritures panier, quelle qu'en soit l'origine ────── */
  function estEcriturePanier(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url));
  }
  function estNotre(init) {
    try {
      var h = init && init.headers;
      if (!h) return false;
      if (typeof h.get === 'function') return !!h.get(MARQUEUR);
      return !!(h[MARQUEUR] || h[MARQUEUR.toLowerCase()]);
    } catch (e) { return false; }
  }

  try {
    window.fetch = function (entree, init) {
      var reponse = _fetch(entree, init);
      try {
        var url = (typeof entree === 'string') ? entree : (entree && entree.url) || '';
        if (estEcriturePanier(url) && !estNotre(init)) {
          reponse.then(planifier, function () {});
        }
      } catch (e) { /* jamais gêner la requête d'origine */ }
      return reponse;
    };
  } catch (e) { /* si le patch échoue, le filet setInterval reste */ }

  function demarrer() {
    setTimeout(sync, 900);
    setInterval(sync, TICK);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
